/**
 * ASIC splits a given name across three fields, and a director with one given
 * name has two empty strings rather than missing keys. Filtering before the
 * join is what avoids the double spaces plain interpolation would leave.
 */
export const fullNameOf = (parts: {
  name1: string;
  name2: string;
  name3: string;
  familyName: string;
}): string =>
  [parts.name1, parts.name2, parts.name3, parts.familyName]
    .map((part) => part.trim())
    .filter(Boolean)
    .join(' ');
